function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.82 24.206V12.465h-5.962c0-4.426 3.342-7.317 6.142-8.22V0c-6.052.994-12.374 5.329-12.374 13.548v10.658h12.193zm-15.626 0V12.465H6.232c0-4.426 3.342-7.317 6.142-8.22V0C6.323.994 0 5.329 0 13.548v10.658h12.194z",
  fill: "#42BBA3"
});

function SvgQuoteMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTI3LjgyIDI0LjIwNlYxMi40NjVoLTUuOTYyYzAtNC40MjYgMy4zNDItNy4zMTcgNi4xNDItOC4yMlYwYy02LjA1Mi45OTQtMTIuMzc0IDUuMzI5LTEyLjM3NCAxMy41NDh2MTAuNjU4aDEyLjE5M3ptLTE1LjYyNiAwVjEyLjQ2NUg2LjIzMmMwLTQuNDI2IDMuMzQyLTcuMzE3IDYuMTQyLTguMjJWMEM2LjMyMy45OTQgMCA1LjMyOSAwIDEzLjU0OHYxMC42NThoMTIuMTk0eiIgZmlsbD0iIzQyQkJBMyIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo=";
export { SvgQuoteMark as ReactComponent };